import api from "@/shared/services/apiClient";

export interface VisaListRow {
  id: string;
  code: string;
  descr: { en?: string; ja?: string };
  active: boolean;
  sort_order: number;
  business_unit: string;
}

export const visaListService = {
  getAll: async (): Promise<VisaListRow[]> => {
    const res = await api.get("/visa-list/list");
    return res.data;
  },

  create: async (data: Omit<VisaListRow, "id" | "business_unit">) => {
    const res = await api.post("/visa-list/create", data);
    return res.data;
  },

  update: async (id: string, data: Omit<VisaListRow, "id" | "code" | "business_unit">) => {
    const res = await api.put(`/visa-list/update/${id}`, data);
    return res.data;
  },

  delete: async (id: string) => {
    const res = await api.delete(`/visa-list/delete/${id}`);
    return res.data;
  },
};
